var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"swiper",rawName:"v-swiper:ReviewSlider",value:(_vm.settings),expression:"settings",arg:"ReviewSlider"}],staticStyle:{"overflow-x":"clip"}},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"relative text-center top-0 z-0 gallery-pagination swiper-pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }